(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-mh-0184"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", (event) => {

  /* ---------------------------------------------------------------
     MH 0184 Cross-Sell

     Geaendert 17.09.2026:
     Der Handler haengt nicht mehr am Klick auf den Haupt-ATC,
     sondern am SUBMIT des Hauptproduktformulars. Haupt-ATC und
     Sticky-ATC senden dasselbe Formular ab (der Sticky-Button
     haengt per form-Attribut daran), damit ist jetzt jeder Weg
     abgedeckt. Zusaetzlich werden die Section-CTAs .wr-cta/.wm-cta
     in der Capture-Phase abgefangen, weil ihr alter Handler das
     falsche Formular traf und einen Seitenreload ausgeloest hat.
     --------------------------------------------------------------- */

  const CARD = '.simple-cross-sell-card-final';

  const checkHidden = () => {
    const products = document.querySelectorAll(CARD);
    const target = document.querySelector('.simple-cross-sell-container-final');
    if (!target) return;
    const hidden = Array.from(products).filter(p => p.classList.contains('hidden'));
    target.classList.toggle('hidden', products.length === hidden.length);
  };

  const getTypes = (variant) => {
    const title = variant.title.toLowerCase();
    let types = [];
    if (title.includes('werkzeug')) { types.push('werkzeug'); }
    if (title.includes('farben'))   { types.push('farben'); }
    return types;
  };

  /* Das Hauptproduktformular erkennen.
     Bewusst ausgeschlossen:
     - die Formulare der Upsell-Karten selbst
     - das Klarna-Ratenformular in product-payment-terms
       (es hat kein is-Attribut und wuerde einen nativen POST ausloesen) */
  const isMainProductForm = (form) => {
    if (!form || typeof form.matches !== 'function') return false;
    if (!form.matches('form[action*="/cart/add"]')) return false;
    if (form.closest(CARD)) return false;
    if (!form.hasAttribute('is')) return false;
    return !!form.closest('.product-form__buy-buttons');
  };

  const getParentLabel = (variantId) => {
    const container = document.querySelector('.simple-cross-sell-container-final');
    if (!container || !variantId) return '';
    try {
      return JSON.parse(container.dataset.parentLabels || '{}')[variantId] || '';
    } catch (error) {
      return '';
    }
  };

  const collectItems = (form) => {
    const parentVariantId = form ? form.querySelector('[name="id"]')?.value : null;
    const parentLabel = getParentLabel(parentVariantId);

    return Array.from(document.querySelectorAll(CARD + '.active'))
      .map((card) => {
        /* MH 10.10.2026: unsichtbare Quelle _q=pdp (Messung je Zubehör-Weg, Wochen-Check) */
        const item = {
          id: card.dataset.productId ? parseInt(card.dataset.productId) : parseInt(card.dataset.id),
          quantity: 1,
          properties: { _q: 'pdp' }
        };

        if (card.dataset.lineItemUpsell === 'true' && parentVariantId) {
          item.properties._upsell_for = parentVariantId;
          if (parentLabel) item.properties['Gehört zu'] = parentLabel;
        }

        return item;
      })
      .filter((item) => !isNaN(item.id));
  };

  const setNotice = (count) => {
    const notice = document.querySelector('.mh-0101-basket-confirm-modal__notice_text');
    if (!notice) return;
    const text = count < 1 ? notice.dataset.single : notice.dataset.multiple;
    if (text) notice.innerText = text;
  };

  const openModal = () => {
    if (typeof triggerEvent === 'function') {
      triggerEvent(document.documentElement, 'product:modal:open');
    }
  };

  const resubmit = (form) => {
    form.dataset.mh0184Pass = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    /* Fallback fuer aeltere Safari-Versionen: ueber den Button,
       damit der ProductForm-Listener greift. Niemals form.submit(),
       das wuerde die Listener umgehen und die Seite neu laden. */
    const btn = form.querySelector('button[type=submit]');
    if (btn) { btn.click(); return; }
    delete form.dataset.mh0184Pass;
  };

  /* --- Ein Listener fuer alle Kaufwege: Submit in der Capture-Phase --- */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!isMainProductForm(form)) return;

    const items = collectItems(form);
    setNotice(items.length);

    /* zweiter Durchlauf nach dem Nachlegen: durchlassen */
    if (form.dataset.mh0184Pass === '1') {
      delete form.dataset.mh0184Pass;
      openModal();
      return;
    }

    /* nichts ausgewaehlt: normaler Ablauf, nichts anfassen */
    if (!items.length) { openModal(); return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    const proceed = () => resubmit(form);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(proceed, proceed);
  }, true);

  /* --- Section-CTAs reparieren ---
     Der Handler in der Custom-Liquid-Section mh_sticky_atc waehlt
     form[action*="/cart/add"] und landet dabei auf dem Klarna-
     Ratenformular -> requestSubmit() -> nativer POST mit Reload,
     ohne Mini-Cart und ohne Zubehoer. Capture laeuft vor dem
     Bubble-Handler, stopImmediatePropagation legt ihn still. */
  document.addEventListener('click', (e) => {
    if (!e.target || typeof e.target.closest !== 'function') return;
    if (!e.target.closest('.wr-cta, .wm-cta')) return;

    const form = document.querySelector('.product__info .product-form__buy-buttons form[action*="/cart/add"]')
              || document.querySelector('form[is=product-form][action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
    const btn = form.querySelector('button[type=submit]');
    if (btn) btn.click();
  }, true);

  const addEventListeners = () => {
    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail.variant;
      const types = getTypes(variant);

      const products = document.querySelectorAll(`${CARD}[data-type]`);
      products.forEach(type => type.classList.add('hidden'));

      products.forEach(product => {
        const isActive = product.classList.contains('active');
        if (!types.includes(product.dataset.type)) {
          product.classList.remove('hidden');
        }
        if (isActive) {
          product.click();
        }
      });

      checkHidden();
    });

    const products = document.querySelectorAll(CARD);
    products.forEach((product) => product.addEventListener('click', () => {
      if (product.classList.contains('disabled')) return;

      product.classList.toggle('active');

      const { id } = product.dataset;
      const basket = document.querySelector(`.mh-0101-basket-confirm-modal__product_card[data-product-id="${id}"]`);
      if (basket) {
        basket.classList.toggle('active', product.classList.contains('active'));
      }
    }));
  };

  addEventListeners();
  checkHidden();
});
  } catch(e) { console.error(e); }
})();

})();
